/**
 * ChatDrawerV2 - Global chat drawer component (Mantine)
 *
 * Wraps ChatContentV2 in a Mantine Drawer.
 * Renders at app root level and is controlled by the chat store.
 * Responsive: full screen on mobile, right-side panel on desktop.
 */

import { isMobile } from 'react-device-detect';
import { Drawer } from '@mantine/core';
import { useChatStore, useChatIsOpen } from '@stores/chatStore';
import ChatContentV2 from './ChatContentV2';

interface ChatDrawerV2Props {
  /** Callback when VIEW PROFILE is clicked */
  onViewProfile?: () => void;
}

function ChatDrawerV2({ onViewProfile }: ChatDrawerV2Props) {
  const isOpen = useChatIsOpen();
  const closeChat = useChatStore((state) => state.closeChat);

  return (
    <Drawer
      opened={isOpen}
      onClose={closeChat}
      position="right"
      size={isMobile ? '100%' : 'xl'}
      padding={0}
      withCloseButton={false}
      title={null}
      styles={{
        body: {
          height: '100%',
          padding: 0,
        },
        content: {
          height: '100%',
        },
      }}
    >
      <ChatContentV2 onViewProfile={onViewProfile} height="100vh" />
    </Drawer>
  );
}

export default ChatDrawerV2;
